// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__dBDdz","buttons":"Footer_buttons__1yZJY"};